var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fetchGallery)?_c('vue-picture-swipe',{attrs:{"items":_vm.fetchGallery}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }